import { render } from "./myPurse.vue?vue&type=template&id=0708c314"
import script from "./myPurse.vue?vue&type=script&lang=js"
export * from "./myPurse.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\28950\\source\\repos\\xtz\\hql\\bm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__